<div class="reset-container">
  <app-reset-left-container class="left-container" />
  <app-reset-right-container class="right-container" />
</div>

<div class="screen-ellipse"></div>
